// Shared theme + helpers for the in-house SVG chart kit. Everything styles
// against the design tokens in index.css :root; series colors are fixed hexes
// because SVG gradients can't reference CSS vars in all engines.

export const COLORS = {
  teal: '#14e0c8',
  violet: '#8b7cff',
  amber: '#f5a623',
  red: '#e5484d',
  green: '#16a34a',
  sky: '#38bdf8',
  muted: '#9aa0a6',
};

// Default series rotation for multi-series charts.
export const SERIES_COLORS = [
  COLORS.teal, COLORS.violet, COLORS.amber, COLORS.sky, COLORS.green, COLORS.red,
];

// Run/job lifecycle → color (kept in one place so every widget agrees).
export const STATUS_COLORS = {
  done: COLORS.green,
  error: COLORS.red,
  running: COLORS.teal,
  active: COLORS.teal,
  launching: COLORS.sky,
  requested: COLORS.amber,
  queued: COLORS.amber,
  stopped: COLORS.muted,
  cancelled: COLORS.muted,
};

export const fmtNum = (n) => {
  if (n == null || Number.isNaN(n)) return '—';
  const abs = Math.abs(n);
  if (abs >= 1e9) return `${(n / 1e9).toFixed(1).replace(/\.0$/, '')}B`;
  if (abs >= 1e6) return `${(n / 1e6).toFixed(1).replace(/\.0$/, '')}M`;
  if (abs >= 1e3) return `${(n / 1e3).toFixed(1).replace(/\.0$/, '')}k`;
  return Number.isInteger(n) ? String(n) : n.toFixed(1);
};

export const fmtDur = (ms) => {
  if (ms == null || Number.isNaN(ms) || ms < 0) return '—';
  if (ms < 1000) return `${Math.round(ms)}ms`;
  const s = ms / 1000;
  if (s < 60) return `${s.toFixed(s < 10 ? 1 : 0)}s`;
  const m = s / 60;
  if (m < 60) return `${Math.floor(m)}m ${Math.round(s % 60)}s`;
  return `${Math.floor(m / 60)}h ${Math.round(m % 60)}m`;
};

export const fmtShortDate = (ts) =>
  new Date(ts).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });

export const fmtTime = (ts) =>
  new Date(ts).toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });

export const prefersReducedMotion = () =>
  typeof window !== 'undefined'
  && window.matchMedia
  && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// "Nice" axis max + tick values for a data max (always includes 0).
export function niceScale(max, tickCount = 4) {
  if (!max || max <= 0) return { max: 1, ticks: [0, 1] };
  const rough = max / tickCount;
  const pow = 10 ** Math.floor(Math.log10(rough));
  const step = [1, 2, 5, 10].map((m) => m * pow).find((s) => s >= rough) || 10 * pow;
  const niceMax = Math.ceil(max / step) * step;
  const ticks = [];
  for (let v = 0; v <= niceMax + step / 2; v += step) ticks.push(v);
  return { max: niceMax, ticks };
}
